
import React, {
  useState,
  useEffect,
  useRef,
  Component,
  useCallback,
} from "react";
import Switch from "react-switch";
import { useLocation } from "react-router-dom";
import cn from "classnames";
import SiteStatus from "../../components/echarts/Sitestatus";
import SitePerformance from "../../components/echarts/SitePerformence";
import Master from "screen/Master";
import styled from "styled-components";
import styles from "./SiteListing.module.scss";
import Button from "@material-ui/core/Button";
import TableAndSearch from "components/common/TableAndSearch";
import { Link } from "react-router-dom";
import {
  getTime,
  getDate,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";

import LocalStorageService from "services/tokenlocalstorage.service";

// import { getRequestInAssets as getRequest} from "../../services/axiosAssetsBaseClient";
import {
  getSitePerformanceRequest,
  getSiteStatusRequest,
} from "../../services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import { getRequest, postRequest } from "services/axiosBaseClient";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";
const Styles = styled.div`
  table {
    th,
    td {
      white-space: wrap;
    }
  }
  .double-screen-pagination {
    margin-top: 40px !important;
    height: 50px;
    padding: 0;
    right: 18px !important;
  }
`;

let multiselectArray = [];
var offset = 0;
var pageLimit = 10;
var sitePaginationLimt = "";

function SiteList(props) {
  const filterInitialValue = {
    startDate: "HOUR_24",
    endDate: "",
    siteId: "",
    chargerId: "",
    stateId: "",
    cityId: "",
    time: "HOUR_24",
    zoneId: "",
  };

  const [droppedFilter, setDroppedFilter] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteCount, setSiteCount] = useState(0);
  const [statusData, setSiteStatusData] = useState([]);
  const [performanceData, setSitePerformanceData] = useState([]);
  const [filter, setFilter] = useState(filterInitialValue);

  const [selectTime, setSelectTime] = useState(24);
  const [sitesList, setSitesList] = useState([]);
  const [sitesListHeader, setSitesListHeader] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [performanceDataLabel, setSitePerformanceLabel] = useState([]);
  const [performanceDataLabelVal, setSitePerformanceLabelVal] = useState([]);
  const [checked, setChecked] = useState(false);
  const [text, setText] = useState(false);
  const [state, setState] = useState(false);
  const [siteStatus, setSiteStatus] = useState([]);
  // const [sitesList, setSitesList] = useState([]);
  const [siteListCount, setsiteListCount] = useState(0);

  const handleChange = (event) => {
    setText(event);

    setState(event);
    getSitePerformanceData(event, filter);

    // if (text === "False") {
    //   setText("False");
    //   setState("True");

    //   getSitePerformanceData("True", filter);
    // } else {
    //   setText("True");

    //   setState("False");

    //   getSitePerformanceData("False", filter);
    // }
  };

  const handleChange2 = (event) => {
    setOpen(false);
  };
  const handleChange1 = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
    if (event.target.name == "time") {
      setSelectTime(event.target.value);
    }
    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, chargerId: "" });
      getChargers(event.target.value);
    }
  };

  const getSites = useCallback(async (filter) => {

    let callString = "bss/site/siteList";
    if (filter?.cityId > 0) {
      callString += "?cityId=" + filter.cityId;
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.stateId > 0) {
      callString += "?stateId=" + filter.stateId;

      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.zoneId > 0) {
      callString += "?zoneId=" + filter.zoneId;
    }
    await getRequestInAssets(callString)
      .then((res) => {
        if (res.data != null) {
          setSitesListHeader(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSitesCount = useCallback(async () => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest("bss/siteTotalCount?" + query)
      .then((res) => {
        if (res.data != null) {
          setSiteCount(res?.data?.totalCount);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    getSites(headerFilterObj);
    if (headerFilterObj !== null) {
      filter.stateId = headerFilterObj.stateId;
      filter.cityId = headerFilterObj.cityId;
      filter.zoneId = headerFilterObj.zoneId;
    }
  }, [props.headerFilter]);

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  const sitePerformanceDataTrue = {
    statusCode: 200,
    message: "top performing sites",
    error: false,
    data: [
      {
        startEnergy: 40,
        maxEnergy: 100,
        minEnergy: 20,
        siteId: 1,
        siteName: "test site",
      },
      {
        startEnergy: 50,
        maxEnergy: 120,
        minEnergy: 10,
        siteId: 2,
        siteName: "string",
      },
      {
        startEnergy: 30,
        maxEnergy: 80,
        minEnergy: 10,
        siteId: 3,
        siteName: "test site",
      },
    ],
  };

  const sitePerformanceDataFalse = {
    statusCode: 200,
    message: "top performing sites",
    error: false,
    data: [
      {
        startEnergy: 140,
        maxEnergy: 300,
        minEnergy: 120,
        siteId: 1,
        siteName: "test site false",
      },
      {
        startEnergy: 150,
        maxEnergy: 220,
        minEnergy: 100,
        siteId: 2,
        siteName: "string false",
      },
      {
        startEnergy: 130,
        maxEnergy: 280,
        minEnergy: 100,
        siteId: 3,
        siteName: "test site false",
      },
    ],
  };

  const [filterData, setChargerMultiSelecct] = useState(multiselectArray);

  const [open, setOpen] = React.useState(false);

  const search = useLocation().search;

  const refOpen = useRef(open);
  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  const handleClick = (btnType) => {
    if (open) {
      if (btnType === "reset") {
        filter.time = filterInitialValue.time;
        filter.siteId = "";
        setSiteStatusData([]);
        setSitePerformanceData([]);
        getSiteStatusData(filter);
        getSitePerformanceData(state, filter);
      } else {
        setSiteStatusData([]);
        setSitePerformanceData([]);
        getSiteStatusData(filter);
        getSitePerformanceData(state, filter);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const setFilterData = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  };

  const getSiteList = useCallback(
    async (time, a, b, c, limit) => {
      return;
      if (c === "front") {
        offset = offset + 10;
      } else {
        if (offset > 0) {
          offset = offset - 10;
        }
      }
      await getRequest(
        `bss/getSiteInformation?${time}&limit=${
          limit ? limit : pageLimit
        }&offset=${offset > 0 ? offset : 0}`
      )
        .then((res) => {
          if (res?.data) {
            setSiteList(res?.data?.siteList);
            setsiteListCount(res.data.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    [siteList, siteListCount]
  );

  const getSitePerformanceData = useCallback(async (e, filter) => {
    let callString =
      "bss/getSiteperformance?topSites=" +
      e +
      "&timeFilterEnum=" +
      filter?.time;
    if (filter.cityId > 0) {
      callString += "&cityId=" + filter.cityId;
    }
    if (filter.stateId > 0) {
      callString += "&stateId=" + filter.stateId;
    }
    if (filter.zoneId > 0) {
      callString += "&zoneId=" + filter.zoneId;
    }
    if (filter.siteId > 0) {
      callString += "&siteId=" + filter.siteId;
    }
    await getSitePerformanceRequest(callString)
      .then((res) => {
        if (res && res?.data) {
          setSitePerformanceData(res?.data);
          var optionData = res;
          var arraLabel = [];
          var arraLabel = [];
          var arraLabelval = [];

          var arr1 = [];
          arraLabel.push("start");
          arraLabel.push("max");
          arraLabel.push("end");
          var colorArr = [
            "#9AAB04",
            "#1CAF9A",
            "#FF5C75",
            "#FFC600",
            "#43BFE5",
          ];
          optionData.data.map(
            (person, index) => (
              (arr1 = []),
              //arraLabel.push(person.siteName),
              (arr1 = [Number(person.start).toFixed(2), Number(person.max).toFixed(2), Number(person.end).toFixed(2)]),
              arraLabelval.push({
                data: arr1,
                name: person.siteName,
                emphasis: {
                  focus: "series",
                },
                type: "line",
                smooth: true,
                areaStyle: {
                  color: colorArr[index],
                },
                lineStyle: {
                  color: colorArr[index],
                },
                itemStyle: {
                  color: colorArr[index],
                },
              })
            )
          );
          setSitePerformanceLabel(arraLabel);
          setSitePerformanceLabelVal(arraLabelval);
        } else {
          setSitePerformanceLabel([]);
          setSitePerformanceLabelVal([]);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  const getSiteStatusData = useCallback(async (filter) => {
    let callString = `bss/getSiteStatus?timeFilterEnum=` + filter.time;
    if (filter.cityId > 0) {
      callString += "&cityId=" + filter.cityId;
    }
    if (filter.stateId > 0) {
      callString += "&stateId=" + filter.stateId;
    }
    if (filter.zoneId > 0) {
      callString += "&zoneId=" + filter.zoneId;
    }
    if (filter.siteId > 0) {
      callString += "&siteId=" + filter.siteId;
    }
    await getSiteStatusRequest(callString)
      .then((res) => {
        if (res && res?.data) {
          setSiteStatusData(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getSitesCount();
    getSiteList(filter);
    getSitePerformanceData("false", filter);
    getSiteStatusData(filter);
    return;
  }, [props.headerFilter]);

  const columns = React.useMemo(() => [
    {
      Header: "Site Name",
      accessor: "siteName",
    },
    {
      Header: "No. of Swapping Stations",
      accessor: "numOfSwapStations",
      Cell: (row) => { 
        return(
          <div style={{ paddingRight:"40px", justifyContent : 'center', display : 'flex' }}>{row.row?.original?.numOfSwapStations? row.row?.original?.numOfSwapStations : 0}</div>
      ) },
      // accessor: row => row.numOfSwapStations? row.numOfSwapStations: 0,
    },
    {
      Header: "Today Energy(kWh)",
      accessor: "tdEnergy",
      Cell: (row) => {
        return  <div style={{ paddingRight:"40px", justifyContent : 'center', display : 'flex' }}>{Math.round(row.value * 100) / 100}</div>;
      },
    },
    {
      Header: "Healthy",
      accessor: "healthy",
      Cell: (row) => {
        return  <div style={{ paddingLeft:"20px"}}>{row.row?.original?.healthy? row.row?.original?.healthy : 0}</div>;
      },
    },
    {
      Header: "Under Maintenance",
      accessor: "underMaintainance",
      Cell: (row) => { 
        return(
          <div style={{ paddingRight:"20px", justifyContent : 'center', display : 'flex' }}>{row.row?.original?.underMaintainance? row.row?.original?.underMaintainance : 0}</div>
      ) },
    },
    {
      Header: "Total Energy(kWh)",
      accessor: "tenergy",
      Cell: (row) => {
        return  <div style={{ paddingLeft:"20px"}}>{row.row?.original?.tenergy? row.row?.original?.tenergy : 0}</div>;
      },
    },
    {
      Header: "Daily Avg Energy(kWh)",
      accessor: "dailyAvgEnergy",
      Cell: (row) => {
        return <div style={{ paddingLeft:"20px"}}>{Math.round(row.value * 100) / 100}</div>
      },
    },
    // {
    //   Header: "Today Energy",
    //   accessor: "tdEnergy",
    // },

    {
      Header: "Action",
      accessor: "siteId",
      disableSortBy: true,
      Cell: (row) => {
        return (
          <>
            <Link
              to={`/sites/site/${row.value}/${
                row.data.find((x) => {
                  return x.siteId === row.value;
                })?.siteName
              }/${
                row.data.find((x) => {
                  return x.siteId === row.value;
                })?.enterprise
              }/0`}
            >
              <img
                src={require("assets/view.png").default}
                style={{ marginRight: 15, cursor: "pointer" }}
              />
            </Link>
          </>
        );
      },
    },
  ]);

  const xAxisData = [
    "Total Sites",
    "Site Commissioned",
    "Site Under Maintenance ",
    "Upcoming  Site",
    "Offline",
  ];

  // var optionData = {
  //   statusCode: 200,
  //   message: "low performing sites",
  //   error: false,
  //   data: [
  //     { siteName: "site name1", start: 20, max: 500, end: 100 },
  //     { siteName: "site name2", start: 50, max: 100, end: 20 },
  //     { siteName: "site name3", start: 100, max: 200, end: 60 },
  //   ],
  // };

  var option1 = {
    color: ["#9AAB04", "#1CAF9A", "#FFC600", "#FFC600", "#43BFE5"],
    tooltip: {
      trigger: "axis",
    },
    legend: {
      type: "scroll",
      //padding: 25,
      show: true,
      itemGap: 5,
      itemWidth: 8,
      top: "1px",
      icon: "circle",
      left: "2%",
      textStyle: {
        fontSize: "11",
        fontFamily: "JioType",
        fontStyle: "normal",
        color: "#9F9F9F",
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: performanceDataLabel,
    },
    grid: {
      top: "13%",
      bottom: "30%",
      left: "20%",
    },
    yAxis: {
      type: "value",
      name: "Energy Discharge (in KWh) till Date",
      nameLocation: "middle",
      nameGap: 42,
    },
    axisLabel: {
      formatter: formatYaxisNumber,
    },
    series: performanceDataLabelVal,
  };

  var data = [
    {
      siteId: 102,
      siteName: "Site 111 A",
      swappingStationNo: 2,
      healthy: 4,
      underMaintainance: 12,
      dailyAvgEnergy: 68,
      avgEnergy: "complicated",
      todayEnergy: 12,
      tenergy: 234,
    },
    {
      siteId: 103,
      siteName: "Site B",
      swappingStationNo: 23,
      healthy: 4,
      underMaintainance: 124,
      dailyAvgEnergy: 636,
      avgEnergy: "complicated",
      todayEnergy: 123,
      tenergy: 234,
    },
    {
      siteId: 103,
      siteName: "Site C",
      swappingStationNo: 21,
      healthy: 41,
      underMaintainance: 112,
      dailyAvgEnergy: 68,
      avgEnergy: "complicated",
      todayEnergy: 12,
      tenergy: 234,
    },
  ];
  const searchBySiteName = (filter, searchString) => {
    if (searchString === undefined || searchString === "") {
      searchString = "";
      getSiteList("timeFilterEnum=HOUR_24");
    }
    if (searchString != "" || searchString != undefined) {
      searchString = `?name=` + searchString;
    }
    getRequest(`bss/getSiteInformation` + searchString)
      .then((res) => {
        if (res && res?.data) {
          setSiteList(res?.data?.siteList);
          setsiteListCount(res.data.count);
        }
      })
      .catch((err) => {});
  };

  const searchBySiteNameFilter = async (filter, searchString) => {
    //topSites=False&timeFilterEnum=HOUR_12
    if (filter === undefined || filter === "") {
      getSiteList("timeFilterEnum=HOUR_24");
    }

    try {
      await getRequest(
        `bss/getSiteInformation?` + filter
        // +`&limit=${
        //   sitePaginationLimt ? sitePaginationLimt : pageLimit
        // }&offset=${offset > 0 ? offset : 0}`
      )
        .then((res) => {
          if (res && res?.data) {
            setSiteList(res?.data?.siteList);
            setsiteListCount(res.data.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    } catch (e) {
      console.log(e, "ERROR");
    }
  };

  return (
    <div id="Sites_Block" className={cn(styles.flex_item1)}>
      <div id="Sites_layout" className={cn(styles.flex1, styles.flex1_layout)}>
        <h2 id="Sites_header_text" className={cn(styles.medium_title, styles.medium_title_layout)}>
          {"Sites"}
        </h2>
        <div id="Sites_TotalCount_Container" className={cn(styles.flex2, styles.flex2_layout)}>
          <div id="Sites_TotalCount_Container1" className={cn(styles.flex2_item)}>
            <div id="Sites_TotalCount_Block" className={cn(styles.cover_block, styles.cover_block_layout)}>
              <div id="Sites_TotalCount_Box" className={cn(styles.box9, styles.box9_layout)}>
                <img
                id="Sites_TotalCount_Img"
                  src={require("assets/sites-white.png").default}
                  alt=""
                  className={cn(styles.box11, styles.box11_layout)}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex2_spacer)} />
          <div id="Sites_TotalCount_TextBlock" className={cn(styles.flex2_item1)}>
            <div id="Sites_TotalCount_Text" className={cn(styles.flex3, styles.flex3_layout)}>
              <h3 id="Sites_TotalCount" className={cn(styles.subtitle, styles.subtitle_layout)}>
                {"Total Count"}
              </h3>
              <h3 id="Sites_TotalCount_Value" className={cn(styles.subtitle1, styles.subtitle1_layout)}>
                {siteCount}
              </h3>
            </div>
          </div>
        </div>

        <div
        id="Sites_GraphFilter"
          ref={wrapperRef}
          style={{ cursor: "pointer" }}
          className={cn(
            styles.graph_filter_block,
            styles.graph_filter_block_layout
          )}
        >
          <div
          id="Sites_GraphFilter_block"
            className={cn(
              styles.graph_filter_text_block,
              styles.graph_filter_text_block_layout
            )}
          >
            <div id="Sites_GraphFilter_title" className={cn(styles.text_body2, styles.text_body2_layout)}>
              {"Filters"}
            </div>
          </div>

          <div id="Sites_GraphFilter_box" className={cn(styles.box16, styles.box16_layout)}>
            <img
              src={require("assets/Vector.svg").default}
              className={cn(styles.box1, styles.box1_layout)}
            />
            <div>
              <div>
                {open && (
                  <div id="filter" open={open} ref={wrapperRefInside}>
                    <div id="Sites_GraphFilter_container"
                      className={cn(
                        styles.status1_block,
                        styles.status1_block_layout
                      )}
                    >
                      <div>
                        <select
                          style={{ width: "80%", height: "35px" }}
                          name="time"
                          id="time"
                          onChange={handleChange1}
                          value={filter.time}
                        >
                          <option value="" disabled>
                            Select Time Period
                          </option>
                          <option value="HOUR_24" selected>
                            Last 24 hours
                          </option>
                          <option value="HOUR_12">Last 12 hours</option>
                          <option value="WEEK">Last 1 week</option>
                          <option value="WEEK_2">Last 2 weeks</option>
                          <option value="MONTH">Last 1 month</option>
                          <option value="MONTH_3">Last 3 months</option>
                        </select>
                      </div>

                      <div>
                        {/* <select
                          style={{ width: "80%", height: "35px" }}
                          name="siteId"
                          id="siteId"
                          onChange={handleChange}
                          value={filter.siteId}
                        >
                          <option value="" disabled selected>
                            Select Site
                          </option>
                          {sitesList.map((obj) => {
                            return <option value={obj.id}>{obj.name}</option>;
                          })}
                        </select> */}

                        <select
                          style={{ width: "80%", height: "35px" }}
                          name="siteId"
                          id="siteId"
                          onChange={handleChange1}
                          value={filter.siteId}
                        >
                          <option value="" disabled selected>
                            Select Site
                          </option>
                          {sitesListHeader.map((obj) => {
                            return <option value={obj.id}>{obj.name}</option>;
                          })}
                        </select>
                      </div>

                      <div>
                        {/* <select
                          style={{ width: "80%", height: "35px" }}
                          name="chargerId"
                          id="chargerId"
                          onChange={handleChange1}
                          value={filter.chargerId}
                        >
                          <option value="" disabled selected>
                            Charger
                          </option>
                          {chargerList.map((obj) => {
                            return <option value={obj.id}>{obj.name}</option>;
                          })}
                        </select> */}
                      </div>

                      <div>
                        <Button
                         id="Sites_GraphFilter_ResetButton"
                          style={{
                            background: "#E3324C",
                            color: "white",
                            margin: "15px 0px 6px 35px",
                            width: "85px",
                            height: "28px",
                          }}
                          onClick={() => {
                            handleClick("reset");
                          }}
                        >
                          Reset
                        </Button>
                        <Button id="Sites_GraphFilter_ApplyButton"
                          style={{
                            background: "#23297A",
                            color: "white",
                            margin: "15px 0px 6px 20px",
                            width: "85px",
                            height: "28px",
                          }}
                          onClick={() => {
                            handleClick("apply");
                          }}
                        >
                          Apply
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div  id="Sites_Graph_Container" className={cn(styles.flex5, styles.flex5_layout)}>
          <div id="Sites_Graph_Container1" className={cn(styles.flex5_item)}>
            <div id="Sites_Graph_SiteStatus_Block" className={cn(styles.group3, styles.group3_layout)}>
              <div id="Sites_Graph_layout" className={cn(styles.flex6, styles.flex6_layout)}>
                <div id="Sites_Graph_SiteStatus_layout" className={cn(styles.flex8, styles.flex8_layout)}>
                  <h5
                  id="Sites_Graph_SiteStatus"
                    className={cn(styles.highlights, styles.highlights_layout1)}
                  >
                    {"Site Status"}
                  </h5>
                </div>
                <div className={cn(styles.box13, styles.box13_layout)}>
                  <SiteStatus
                    yAxisData={[
                      statusData.totalSites,

                      statusData.commissionedSites,

                      statusData.underMaintainance,

                      statusData.upcomingSites,
                      
                      statusData.offline
                    ]}
                    xAxisData={xAxisData}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.flex5_spacer)} />
          <div id="Sites_Graph_container2" className={cn(styles.flex5_item)}>
            <div id="Sites_Graph_SitePerforming_block" className={cn(styles.group3, styles.group3_layout)}>
              <div id="Sites_Graph_SitePerforming_block1" className={cn(styles.flex6, styles.flex6_layout)}>
                <div id="Sites_Graph_SitePerforming_layout" className={cn(styles.flex8, styles.flex8_layout)}>
                  <h5
                  id="Sites_Graph_SitePerforming"
                    className={cn(styles.highlights, styles.highlights_layout1)}
                  >
                    {"Site Performing"}
                  </h5>

                  <div className={cn(styles.flex8_spacer)} />
                  <div className={cn(styles.flex8_item)}>
                    <div style={{ display: "flex" }}>
                      <label>
                        <span
                          style={{ fontSize: "small", marginRight: "10px" }}
                        >
                          {text}
                        </span>
                      </label>
                      <Switch
                        onChange={handleChange}
                        checked={state}
                        onColor="#DADADA"
                        onHandleColor="#23297A"
                        offColor="#DADADA"
                        handleDiameter={20}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={48}
                        className="react-switch"
                        id="material-switch"
                      />
                    </div>
                  </div>
                </div>

                <div className={cn(styles.box13, styles.box13_layout)}>
                  <SitePerformance
                    performanceDataLabelVal={performanceDataLabelVal}
                    performanceDataLabel={performanceDataLabel}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <hr className={cn(styles.line, styles.line_layout)} /> */}
        <hr className={cn(styles.line, styles.line_layout)} />

        <Styles>
          <div className={cn(styles.gridTable)}>
            <NewTableAndSearchMasterFilter
              searchOpts={{
                placeholder: "Search by Site Name",
                filter: true,
                // screentype: "swapping",
                onFilterSearch: searchBySiteNameFilter,
              }}
              headerFilter={props.headerFilter}
              columns={columns}
              data={siteList}
              onReset={getSiteList}
              paginationDoubleScreen={true}
              swapStationCount={siteListCount}
            />
          </div>
        </Styles>
      </div>
    </div>
  );
}

export default function SiteListing(props) {
  const filterInitialValue = {
    startDate: "",
    endDate: "",
    siteId: "",
    chargerId: "",
    stateId: "",
    cityId: "",

    zoneId: "",
  };
  const [filter, setFilter] = useState(filterInitialValue);
  let Urls = window.location.href.toString().split(window.location.host)[1];
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master
        siteName={Urls}
        opts={props}
        screen={SiteList}
        showStatus={true}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

SiteListing.inStorybook = true;
